import { Box, styled, Typography } from "@mui/material"
import { Link } from "react-router-dom"
import { colors } from "../../theme/colors"

export const StyledLink = styled(Link)({
  textDecoration: "none",
})

export const TransactionContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 14,
})

export const TransactionTextsContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: "1",
})

export const TransactionTextContainer = styled(Box)({
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between",
})

export const TransactionSource = styled(Typography)({
  color: colors.lightBlack,
  fontSize: 18,
  lineHeight: "24px",
})

export const TransactionDescription = styled(Typography)({
  color: colors.darkGrey,
  fontSize: 14,
  lineHeight: "18px",
})

export const TransactionAmount = styled(Typography)({
  color: colors.lightBlack,
  fontSize: 18,
  fontWeight: 500,
  lineHeight: "24px",
})

export const TransactionTime = styled(Typography)({
  color: colors.darkGrey,
  fontSize: 14,
  lineHeight: "18px",
})

export const TransactionIcon = styled(Box)({
  width: 46,
  height: 46,
  borderRadius: "40%",
  background: colors.yellow,
})
